import { useState } from "react";
import { useTranslation } from "react-i18next";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import { SUPPORTED_LANGUAGES } from "@/i18n";

export default function LanguageSwitcher() {
  const { i18n, t } = useTranslation();
  const [anchorEl, setAnchorEl] = useState(null);
  const currentLanguage =
    SUPPORTED_LANGUAGES.find(({ code }) => code === i18n.language) ||
    SUPPORTED_LANGUAGES[0];

  const handleClose = () => setAnchorEl(null);

  const handleSelect = (language) => {
    if (language !== currentLanguage.code) {
      i18n.changeLanguage(language);
    }
    handleClose();
  };

  return (
    <>
      <Tooltip title={t("language.select")}>
        <IconButton
          color="inherit"
          size="small"
          onClick={(event) => setAnchorEl(event.currentTarget)}
          aria-label={t("language.select")}
          aria-controls={anchorEl ? "language-menu" : undefined}
          aria-expanded={anchorEl ? "true" : undefined}
          aria-haspopup="menu"
          data-testid="language-switcher"
        >
          <Typography
            component="span"
            aria-hidden="true"
            sx={{ fontSize: "1.25rem", lineHeight: 1 }}
          >
            {currentLanguage.label}
          </Typography>
        </IconButton>
      </Tooltip>
      <Menu
        id="language-menu"
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
      >
        {SUPPORTED_LANGUAGES.map((language) => (
          <MenuItem
            key={language.code}
            selected={language.code === currentLanguage.code}
            onClick={() => handleSelect(language.code)}
            data-testid={`language-option-${language.code}`}
          >
            <Typography
              component="span"
              aria-hidden="true"
              sx={{ mr: 1, fontSize: "1.1rem", lineHeight: 1 }}
            >
              {language.label}
            </Typography>
            {t(language.nameKey)}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}
